import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSetRecoilState } from 'recoil';
import { DialogMessageState, MoveButtonState } from '../../recoil/states';
import { asyncReqBoardInfo } from '../../reducers/BoardInfoReducer';
import { AppDispatch, RootState } from '../../Store';
import CommonUtil from '../../utils/CommonUtil';
import { Paper } from '@mui/material';

const CommentNewList = () => {

    const CommentNewListReducer_Result = useSelector((state: RootState) => state.CommentNewListReducer); // 상단 신규 댓글 표시 처리를 위한 state
    const setDialogMessageState = useSetRecoilState(DialogMessageState); // 다일얼로그 메세지 요청 정보를 갖는 state
    const setMoveButtonState = useSetRecoilState(MoveButtonState); // '순차 / 랜덤' 버튼 클릭 여부 정보를 갖는 state
    const dispatch = useDispatch<AppDispatch>();

    if (CommentNewListReducer_Result.status === "LOADING") {
        // 댓글 목록 > 통신 중 일 경우

        // 로딩바 표시
    }
    else if (CommentNewListReducer_Result.status === "FAIL") {
        // 댓글 목록 > 통신 실패된 경우

        const message = "신규 댓글 목록 가져오기 실패, 통신 처리 중 알 수 없는 오류가 발생하였습니다.";
        setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
    }
    else if (CommentNewListReducer_Result.status === "COMPLETE") {
        // 댓글 목록 > 통신 성공된 경우

        if (CommentNewListReducer_Result.n4ErrorCode !== 0) {

            const message = CommentNewListReducer_Result.strErrorMessage;
            setDialogMessageState(rawState => ({ ...rawState, isShow: true, isConfirm: false, message }));
        }
    }

    useEffect(() => {

        $("#nav_New_Reply_Root").show();

        if (!Array.isArray((window as any).newReplyRollIds)) (window as any).newReplyRollIds = []; // 이전에 생성된 객체에 대한 자원 해제 처리를 위한 준비

        // 최신댓글 목록 롤링 처리
        (window as any).curr_new_comment_idx = 0;
        (window as any).interval_comment_roll_id = setInterval(() => {

            (window as any).curr_new_comment_idx++;

            if ((window as any).curr_new_comment_idx >= $(".uggiyo_custom_new_reply_item").length) (window as any).curr_new_comment_idx = 0;

            $(".uggiyo_custom_new_reply_item").slideUp("slow");
            $(".uggiyo_custom_new_reply_item").eq((window as any).curr_new_comment_idx).slideDown("slow");
        }, 5000);

        // 이전에 생성했던 롤링 ID가 존재할 경우, 자원해제
        while ((window as any).newReplyRollIds.length) {
            const id = (window as any).newReplyRollIds.shift();
            clearInterval(id);
        }

        (window as any).newReplyRollIds.push((window as any).interval_comment_roll_id); // 현재 생성된 롤링 ID 저장

        return () => {
            clearInterval((window as any).interval_comment_roll_id);
        }
    }, []);

    /**
     * 댓글과 관련된 게시판 상세로 이동
     * @param e 이벤트 객체
     * @param board_seq 게시판 고유번호
     */
    const handlerCommentDetail = (e: React.MouseEvent<HTMLUListElement, MouseEvent>, board_seq: string, comment_seq: string): void => {

        // '랜덤' 버튼 클릭 알림 (마지막으로 본 고유번호 갱신되지 않도록 하기 위함)
        setMoveButtonState(rawState => ({ ...rawState, isClickBtnOrder: false, isClickBtnRandom: true }));

        if (navigator.userAgent.indexOf(";UGGIYO_APP;") > -1) {
            // 앱 내 호출일 경우
            const AppWebView = (window as any).AppWebView;
            if (typeof (AppWebView) !== "undefined") {
                if (typeof (AppWebView.show_New_Comment_Detail) === "function") {

                    AppWebView.show_New_Comment_Detail(board_seq, comment_seq);
                }
            }
        }
        else {
            // 그 외
            const url: string = "/board_info?seq=" + encodeURIComponent(board_seq) + "&c_seq=" + encodeURIComponent(comment_seq);
            (window as any).urlChange(url);

            const view_type: string = "CURR"; // '보기 유형' 파라메터 가져오기
            dispatch(asyncReqBoardInfo({ view_type, board_seq })); // 게시물 상세 정보 가져오기

            CommonUtil.scrollTo("header", -7, 0); // 상단 메뉴 영역 안보이게 스크롤바 자동 이동
        }
    }

    return (
        <nav className="bo_cate" id="nav_New_Reply_Root" style={{ width: "100%", height: "62px", background: "#f5f5f5", display: "none" }}>
            {
                CommentNewListReducer_Result.LIST.map((item, idx) => (

                    <ul key={idx} className="bo_cate_ul uggiyo_custom_new_reply_item" style={{ cursor: "pointer", display: idx === 0 ? "block" : "none" }} onClick={e => handlerCommentDetail(e, item.UBC_BOARD_SEQ, item.UBC_COMMENT_SEQ)}>
                        <li><a href="#none" className="bo_cate_on" onClick={e => e.preventDefault()}>최신댓글</a></li>
                        <li
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                fontWeight: "bold",
                                gap: "6px",           // 아이콘/날짜 간격
                                float: "right",       // 기존 레이아웃 유지가 필요하면 남겨둠(가능하면 class로 대체 권장)
                                maxWidth: "100%",     // 우측 박스 자체 폭 한정
                            }}
                        >
                            <b
                                title={item.UMM_NICKNAME} // 전체 닉네임 툴팁
                                style={{
                                    minWidth: 0, // flex에서 말줄임 필수
                                    maxWidth: "40vw", // 필요시 조절(예: 40vw/300px 등)
                                    display: "inline-block",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    textAlign: "right",
                                }}
                            >{item.UMM_NICKNAME}</b>
                            <i className="fa fa-clock-o" aria-hidden="true"></i>&nbsp;
                            {item.UBC_REG_DT}
                        </li>
                        <li style={{ textOverflow: "ellipsis", whiteSpace: "nowrap", wordWrap: "normal", width: "100%", overflow: "hidden" }}>
                            <div dangerouslySetInnerHTML={{ __html: item.UBC_CONTENT }}>
                            </div>
                        </li>
                    </ul>
                ))
            }
        </nav>
    )
}

export default CommentNewList;
